{
  "acceptedFileFormats": "Solo se aceptan archivos .docx, .pdf, .txt.",
  "actionCompetenceGroup": "Grupo de Competencia de Acción",
  "actionDeadline": "Fecha Límite de Acción",
  "actionDescription": "Descripción de Acción",
  "actionDuration": "Duración de Acción",
  "actionEarliestStart": "Inicio Más Temprano de Acción",
  "actionName": "Nombre de Acción",
  "actions": "Acciones",
  "actionsAndProjects": "Acciones y Proyectos",
  "actionsColon": "Acciones: ",
  "actionsPerformerConstraints": "Restricciones de Ejecutor de Acciones",
  "add": "Añadir",
  "addAdmin": "Añadir Administrador",
  "addAdminTitle": "Añadir Administrador",
  "addAnalyses": "Añadir análisis",
  "addAnalysis": "Añadir Análisis",
  "addAnalysisGroup": "Añadir un grupo de análisis",
  "addChatbot": "Añadir chatbot",
  "addCompetenceGroup": "Añadir Grupo de Competencia",
  "addConstraint": "Añadir restricción",
  "addGreyTask": "Añadir una Tarea Gris",
  "addInstrument": "Añadir un Instrumento",
  "addItemPlaceholder": "Añadir {{item}}...",
  "addLocation": "Añadir ubicación",
  "addMaintenance": "Añadir mantenimiento",
  "addMember": "Añadir miembro",
  "addNewBundle": "Añadir Nuevo Paquete",
  "addNewMaintenanceFor": "Añadir nuevo mantenimiento para {{assetName}}",
  "addNewTask": "Añadir una nueva tarea",
  "addOffsite": "Añadir FUERA DE SITIO",
  "addProjectGroup": "Añadir un grupo de proyectos",
  "addProjectTemplate": "Añadir Plantilla de Proyecto",
  "addRepository": "Añadir repositorio",
  "addRow": "Añadir Fila",
  "addSample": "Añadir muestra",
  "addSamples": "Añadir muestras",
  "addTeam": "Añadir equipo",
  "additionalInformation": "Información Adicional",
  "administrators": "Administradores",
  "advanced": "Avanzado",
  "allFilesProcessed": "Todos los archivos cargados han sido procesados",
  "allowMembersMoveOthersOperationalTasks": "Permitir a los miembros mover tareas operativas de otros",
  "allowedCompetenceGroups": "Grupos de Competencia Permitidos",
  "allowedInstruments": "Instrumentos permitidos",
  "amountOfSamples": "Cantidad de muestras: {{count}}",
  "analyses": "Análisis",
  "analysesRelatedTo": "Análisis relacionados con {{product}}",
  "analysis": "Análisis",
  "analysisAndSampleDone": "El análisis y la muestra están terminados",
  "analysisDefinition": "definición de análisis",
  "analysisDesignTool": "Herramienta de Diseño de Análisis",
  "analysisDone": "El análisis está terminado",
  "analysisDraft": "BORRADOR de Análisis",
  "analysisGroup": "Grupo de análisis",
  "analysisGroupName": "Nombre del Grupo de Análisis",
  "analysisIsFlagged": "El análisis está marcado",
  "analysisMustContainTaskDefinition": "El análisis debe contener una definición de tarea",
  "analysisName": "Nombre del Análisis",
  "analysisNameMustBeUnique": "El Nombre del Análisis debe ser único",
  "analysisNotPlanned": "Este análisis no está planificado",
  "analysisPlanned": "El análisis está planificado",
  "analysisTaskBundle": "Paquete de Tarea de Análisis {{index}}",
  "cdmoTargetedBundle": "Agrupar tareas por nombre de análisis",
  "analysisTaskTimePerformerSamples": "Tarea de Análisis - Tiempo, Ejecutor, Número de Muestras",
  "analysisTasks": "tareas de análisis",
  "analysisTasksToBundle": "Tareas de Análisis a Agrupar",
  "analysisTimePercentage": "Porcentaje de tiempo de análisis respecto al tiempo total (A2T)",
  "anywhere": "En cualquier lugar",
  "apiToken": "Token API",
  "archiveMember": "Archivar Miembro",
  "archived": "archivado",
  "areYouSureConnection": "¿Está seguro de que desea establecer esta conexión?",
  "areYouSureConnectionMode": "¿Está seguro de que desea entrar en modo \"con conexión\"? Esto eliminará todas las conexiones actuales",
  "areYouSureDeleteAdmin": "¿Está seguro de que desea eliminar este administrador?",
  "areYouSureDiscardSimulation": "¿Está seguro de que desea descartar los cambios realizados en modo simulación?",
  "areYouSurePublishSimulation": "¿Está seguro de que desea publicar los cambios realizados en modo simulación?",
  "areYouSureReset": "¿Está seguro de que desea restablecer? Esto eliminará todos los nodos.",
  "areYouSureUnplanAllFutureActions": "¿Está seguro de que desea desplanificar todas las acciones futuras en este proyecto?",
  "areYouSureWantToExit": "¿Está seguro de que desea salir?",
  "arrival": "Llegada",
  "assetAddedOrRemoved": "Se ha añadido o eliminado un activo",
  "assetRequirementsForAsset": "Requisitos de Activo para el Activo {{index}}",
  "assets": "Activos",
  "atLeast1LowercaseLetter": "al menos 1 letra minúscula",
  "atLeast1Number": "al menos 1 número",
  "atLeast1UppercaseLetter": "al menos 1 letra mayúscula",
  "atLeast8Characters": "al menos 8 caracteres",
  "automaticImportConversionSheet": "Hoja de Conversión de Importación Automática de {{type}}",
  "automaticSheetConfiguration": "Configuración de Hoja Automática",
  "availability": "Disponibilidad",
  "availableTimeOneWeek": "Tiempo disponible una semana: ",
  "avgAnalysisDuration": "Duración promedio del análisis: ",
  "avgSampleBatchInterval": "Intervalo promedio del lote de muestras: ",
  "avgSamplesAllocated": "Número promedio de muestras asignadas: ",
  "backlog": "Trabajo Pendiente",
  "booked": "Reservado",
  "bookedBy": "Reservado por",
  "byCompetenceGroup": "Por Grupo de Competencia",
  "byDeadline": "Por Fecha Límite",
  "byGroup": "Por Grupo",
  "byText": "Por Texto",
  "canBePerformedAnywhere": "Puede realizarse en cualquier lugar",
  "canOnlyBePerformedOnSite": "Solo puede realizarse en el sitio",
  "cancel": "Cancelar",
  "cancelChanges": "Cancelar Cambios",
  "cannotUnlockStartedTasks": "No puede desbloquear esto ya que una o más tareas están iniciadas/pausadas/finalizadas",
  "changeLogs": "Registros de Cambios",
  "changesHaveBeenMade": "Se han realizado cambios, recargue para obtener datos nuevos",
  "chatbotGreeting": "Hola, soy su CHATBOT de IA, especializado en documentación de ayuda de Plannertech y Librarian, y los repositorios de datos que ha importado.\nTambién puede contactar con nuestro Soporte Humano en pt@arnvind.com de 9 a 16 CET.\n¿En qué puedo ayudarle? :-)",
  "chatbotName": "Nombre del Chatbot",
  "chatbotPlaceholder": "Escriba una breve descripción de cómo debe comportarse el chatbot.",
  "chatbots": "Chatbots",
  "chattingWith": "Chateando con {{name}}",
  "chooseAction": "Elegir Acción",
  "chooseTask": "Elegir Tarea",
  "chooseWhatToAdd": "Elegir qué añadir",
  "cleanUp": "Limpiar",
  "clear": "Limpiar",
  "clearConversation": "Borrar la conversación",
  "clearDates": "Borrar Fechas",
  "clearTable": "Limpiar Tabla",
  "clickToSelectOtherFiles": "Haga clic para seleccionar otros archivos",
  "close": "Cerrar",
  "closeMessage": "cerrar mensaje",
  "closePanel": "Cerrar panel",
  "collaborator": "Colaborador",
  "collaborators": "Colaboradores",
  "domain": "Dominio",
  "color": "Color",
  "columnName": "Nombre de Columna",
  "companyWideChatbot": "Chatbot para toda la empresa",
  "competenceAndInstrumentConstraints": "Restricciones de Competencia e Instrumento",
  "competenceGroup": "Grupo de Competencia",
  "competenceGroupNameExists": "Ya existe un grupo de competencia con ese nombre",
  "competenceGroups": "Grupos de Competencia",
  "competenceGroupsColon": "Grupos de Competencia: ",
  "configuration": "Configuración",
  "confirm": "Confirmar",
  "confirmArchivalOfMember": "Confirmar archivado del miembro: {{initials}}",
  "confirmClearTable": "¿Está seguro de que desea limpiar la tabla?",
  "confirmDeleteAllData": "Al confirmar se eliminarán todos los datos de {{type}}. No hay vuelta atrás, ni siquiera con el Modo Simulación.",
  "confirmDeleteAllUnplannedProjects": "Al confirmar se eliminarán todos los proyectos que no tienen acciones en el plan",
  "confirmDeleteAllUnplannedSamples": "Al confirmar se eliminarán todas las muestras que no tienen acciones en el plan",
  "confirmDeleteCompetenceGroup": "Confirmar eliminación del grupo de competencia:",
  "confirmDeleteInstrument": "¿Está seguro de que desea eliminar el instrumento: {{name}}?",
  "confirmDeleteMaintenance": "¿Está seguro de que desea eliminar este mantenimiento?",
  "confirmDeleteSample": "¿Está seguro de que desea eliminar esta muestra no planificada?",
  "confirmDeleteSampleInfo": "Al confirmar se eliminará permanentemente la muestra seleccionada",
  "confirmDeletion": "Confirmar eliminación",
  "confirmFailSamples": "¿Está seguro de que desea marcar como fallidas las muestras seleccionadas?",
  "confirmFailSamplesInfo": "Al confirmar se marcarán como fallidas las muestras seleccionadas. Se colocará un duplicado en el menú de análisis no planificados",
  "confirmFailSamplesQuestion": "¿Está seguro de que desea marcar como fallidas las muestras seleccionadas?",
  "confirmShowPlannedSamplesInfo": "Al confirmar se mostrarán las muestras planificadas",
  "confirmShowPlannedSamplesQuestion": "¿Está seguro de que desea mostrar las muestras planificadas?",
  "confirmSortByTime": "¿Está seguro de que desea ordenar por tiempo",
  "confirmUnplanAllFutureActions": "¿Está seguro de que desea desplanificar todas las acciones futuras en este proyecto?",
  "confirmUnplanAllQuestion": "¿Está seguro de que desea desplanificar todos los {{itemType}}?",
  "confirmUnplanSamplesInfo": "Al confirmar se desplanificarán las muestras seleccionadas. Se colocarán en el menú de análisis no planificados",
  "confirmUnplanSamplesQuestion": "¿Está seguro de que desea desplanificar las muestras seleccionadas?",
  "connectionCalculatedInWorkdays": "Conexión calculada en días laborables",
  "connectionCount": "Número de Conexiones",
  "connections": "Conexiones",
  "connectionsAdvancedWarning": "(El uso de conexiones con fecha límite o inicio más temprano en acciones es para usuarios avanzados)",
  "connectionsPerformersOnly": "Las conexiones son solo para ejecutores — no afecta la asignación de activos",
  "contactArnvindSupport": "Por favor contacte el soporte de Arnvind en pt@arnvind.com",
  "conversionSheet": "Hoja de Conversión",
  "copyToClipboard": "copiar al portapapeles",
  "country": "País",
  "create": "Crear",
  "createANewColumn": "Crear una nueva Columna",
  "createAction": "Crear Acción",
  "createChatbot": "Crear chatbot",
  "createEditChatbots": "Crear/editar chatbots",
  "createEditRepositories": "Crear/editar repositorios",
  "createNewColumn": "Crear una nueva Columna",
  "createNewProject": "Crear Nuevo Proyecto",
  "createSingleAction": "Crear Acción Individual",
  "createStage": "Crear Etapa",
  "createStandardAction": "Crear Acción Estándar",
  "currentlyProcessingRepository": "Actualmente procesando este repositorio",
  "daily": "Diario",
  "date": "Fecha",
  "dateUnavailable": "Fecha No Disponible",
  "day": "día",
  "dayS": "día(s)",
  "days": "día(s)",
  "daysBeforeExpirationWarning": "Días antes del vencimiento para mostrar aviso",
  "daysBetweenRecurrences": "Días Entre Recurrencias",
  "deadline": "Fecha Límite",
  "deadlineColon": "Fecha Límite: ",
  "deadlineDate": "Fecha de vencimiento",
  "deadlineMustBeLaterThanEarliestStart": "La fecha límite debe ser posterior o igual al inicio más temprano",
  "deadlineTime": "Hora Límite",
  "defaultChatbot": "Chatbot predeterminado",
  "delete": "Eliminar",
  "deleteAllTypeTestData": "Eliminar todos los datos de prueba de {{type}}",
  "deleteAllUnplannedProjects": "Eliminar todos los Proyectos No Planificados",
  "deleteAllUnplannedSamples": "Eliminar todas las Muestras No Planificadas",
  "deleteColumn": "Eliminar Columna",
  "deleteCompetenceGroup": "Eliminar Grupo de Competencia",
  "deleteCompetenceGroupWarning": "Al eliminarlo se dejarán tareas en los siguientes análisis sin un Grupo de Competencia. Asegúrese de reemplazarlo antes de eliminar.",
  "deleteConstraint": "Eliminar restricción",
  "deleteData": "Eliminar Datos",
  "deleteInstrument": "Eliminar Instrumento",
  "deleteInstrumentWarning": "También se eliminará para otros equipos en esta ubicación.",
  "deleteProjects": "Eliminar Proyectos",
  "deleteSample": "Eliminar Muestra",
  "deleteSamples": "Eliminar Muestras",
  "deleteThisRow": "Eliminar esta fila",
  "description": "Descripción",
  "designTool": "Herramienta de Diseño",
  "done": "Hecho",
  "draft": "borrador",
  "dragAndDropFiles": "Arrastre y suelte archivos aquí, o haga clic para seleccionar archivos",
  "dragAndDropFolders": "Arrastre y suelte carpetas aquí, o haga clic para seleccionar archivos específicos",
  "dropFilesHere": "Suelta los archivos aquí",
  "dropFoldersHere": "Suelte las carpetas aquí...",
  "duplicate": "Duplicar",
  "durationHHMM": "Duración (HH:MM)",
  "earliestStart": "Inicio Más Temprano",
  "edit": "Editar",
  "editAction": "Editar Acción",
  "editAdmin": "Editar Administrador",
  "editAnalysisGroup": "Editar grupo de análisis",
  "editAnalysisTask": "Editar Tarea de Análisis",
  "editChatbot": "Editar chatbot",
  "editCompetenceGroup": "Editar Grupo de Competencia",
  "editConnectionFromTo": "Editar conexión de {{from}} a {{to}}",
  "editConversation": "Editar Conversación",
  "editGroup": "Editar grupo",
  "editInstrument": "Editar Instrumento",
  "editItem": "Editar {{item}}",
  "editLocationName": "Editar nombre de ubicación",
  "editMaintenanceFor": "Editar {{name}} para {{assetName}}",
  "editMember": "Editar miembro",
  "editOffsite": "Editar FUERA DE SITIO",
  "editProject": "Editar Proyecto",
  "editProjectGroup": "Editar grupo de proyectos",
  "editProjectTemplate": "Editar Plantilla de Proyecto",
  "editProjectTemplateDraft": "Editar BORRADOR de Plantilla de Proyecto",
  "editRepository": "Editar repositorio",
  "editSampleName": "Editar muestra: {{name}}",
  "editSheet": "Editar Hoja {{name}}",
  "editStandardAction": "Editar Acción Estándar",
  "editTask": "Editar tarea",
  "editTeam": "Editar equipo",
  "edited": "Editado",
  "email": "correo electrónico",
  "emailCannotContainDoubleDots": "El correo electrónico no puede contener '..'",
  "emailLabel": "Correo electrónico",
  "endDate": "Fecha de fin",
  "enterSimulationMode": "Entrar en Modo Simulación",
  "errors": "Errores",
  "errorsProcessingRepository": "Hubo errores al procesar este repositorio",
  "estimatedWorkloadOneWeek": "Carga de trabajo estimada una semana: ",
  "exclusive": "Exclusivo",
  "exclusiveSampleIndicator": "* Indica una muestra exclusiva",
  "exitSimulation": "SALIR DE SIMULACIÓN",
  "exitSimulationMode": "Salir del modo simulación",
  "expand": "Expandir",
  "exportToExcel": "Exportar a Excel",
  "fail": "Fallo",
  "failSample": "Marcar Muestra como Fallida",
  "failSelected": "Marcar Seleccionados como Fallidos",
  "failedLoading": "Error al cargar: {{members}}",
  "failedToCreateMaintenance": "Error al crear el mantenimiento \"{{name}}\"",
  "failedToDeleteMaintenance": "Error al eliminar el mantenimiento \"{{name}}\"",
  "failedToMarkMaintenanceAsCompleted": "Error al marcar el mantenimiento \"{{name}}\" como completado",
  "failedToUpdateMaintenance": "Error al actualizar el mantenimiento \"{{name}}\"",
  "failedUploads": "Cargas Fallidas",
  "fileUpload": "Carga de Archivo",
  "fileUploadError": "Ocurrió un error durante la carga del archivo",
  "filenameLabel": "Nombre de archivo: ",
  "filesUploadedSuccessfully": "Archivos cargados exitosamente",
  "fillIn": "Rellenar",
  "fillInIgnoreOverbooking": "Rellenar Ignorando Sobrecontratación",
  "filter": "Filtrar",
  "filterByName": "Filtrar por Nombre",
  "filterBySampleName": "Filtrar por Nombre de Muestra",
  "filterBySampleProductName": "Filtrar por Nombre de Muestra/Producto",
  "filterByText": "Filtrar por Texto",
  "finished": "Finalizado",
  "flag": "Marcar",
  "flagSample": "Marcar Muestra",
  "followingErrorsWhileImporting": "Siguientes errores durante la importación:",
  "free": "Libre",
  "from": "De",
  "fromDate": "Desde la fecha",
  "fromTime": "Desde hora (HH:MM)",
  "fromTimeHH": "Desde hora (HH)",
  "fromTimeHHMM": "Desde hora (HH:MM)",
  "futureAnalysisTaskCantBe": "Una tarea de análisis futura no puede ser {{state}}",
  "generate": "Generar",
  "globalChatbot": "Chatbot global",
  "goBack": "Volver",
  "goBackToChat": "Volver al chat",
  "greyTaskTimePercentage": "Porcentaje de tiempo de tarea gris respecto al tiempo total (G2T)",
  "groupMembers": "Miembros del Grupo",
  "groupName": "Nombre del Grupo",
  "help": "Ayuda",
  "helpBackToApp": "Volver a la aplicación",
  "helpHome": "Inicio de ayuda",
  "helpPageNotFound": "Página de ayuda no encontrada",
  "helpSearch": "Buscar ayuda",
  "helpAppTitle": "Ayuda de Plannertech",
  "hidden": "Oculto",
  "hideMore": "Ocultar más",
  "highestPriority": "1 es la prioridad más alta",
  "history": "Historial",
  "home": "Inicio",
  "hour": "hora",
  "iCalendarOutlookIntegration": "Integración iCalendar / Outlook",
  "iap": "IAP",
  "ignoreAllGreytasks": "Ignorar Todas las Tareas Grises",
  "ignoredByIap": "Ignorado por IAP",
  "includingToday": "Incluido hoy",
  "importedTask": "Tarea importada",
  "busyOnAnotherTeam": "Ocupado en otro equipo",
  "includeDoneSamples": "Incluir muestras terminadas",
  "includeOverdue": "Incluir Vencidas",
  "includeToday": "Incluir Hoy",
  "iapIncludeTodayWarningIAP": "Advertencia IAP e Incluir Hoy — las tareas planificadas anteriormente hoy también pueden moverse a menos que estén bloqueadas.",
  "iapIncludeTodayWarningFillIn": "Advertencia Rellenar e Incluir Hoy — las tareas planificadas anteriormente hoy también pueden recibir nuevas muestras asignadas.",
  "initials": "Iniciales",
  "inputLastMonth": "Entrada Mes Pasado",
  "inputThisMonth": "Entrada Este Mes",
  "instrument": "Instrumento",
  "instrumentConstraints": "Restricciones de Instrumento",
  "instrumentLog": "Registro de Instrumento",
  "instrumentName": "Nombre del Instrumento",
  "instrumentOffset": "Compensación de instrumento (HH:MM)",
  "instrumentOverbooking": "Sobrecontratación de Instrumento",
  "instrumentPerSampleDuration": "Duración del instrumento por muestra (HH:MM:SS)",
  "instrumentSetup": "Configuración del Instrumento {{name}}",
  "instrumentSetuptime": "Tiempo de configuración del instrumento (HH:MM)",
  "instrumentTime": "Tiempo de Instrumento",
  "instrumentView": "Vista de Instrumento",
  "instruments": "Instrumentos",
  "instrumentsWithExpiredMaintenance": "Hay instrumentos con mantenimiento vencido",
  "instrumentsWithMaintenanceReminders": "Hay instrumentos con recordatorios de mantenimiento",
  "integration": "Integración",
  "invalidDate": "Fecha Inválida",
  "invalidOutlookLink": "Enlace iCalendar / Outlook inválido",
  "isInSimulationMode": "{{initials}} está en modo simulación",
  "isSimulating": "{{initials}} está simulando...",
  "keepExistingConnections": "Mantener conexiones existentes",
  "labelAlreadyLoaded": "Ya cargado: {{count}}",
  "labelCreated": "Creado: {{count}}",
  "labelDeleted": "Eliminado: {{count}}",
  "labelDeletedOrFinished": "Eliminado o marcado como finalizado: {{count}}",
  "labelDoneDeleted": "Hecho/Eliminado: {{count}}",
  "labelUpdatedInformation": "Información actualizada: {{count}}",
  "lastErrorLog": "Último Registro de Errores",
  "lastWeek": "Semana Pasada",
  "latestArrival": "Última Llegada",
  "leadTimesInWorkDays": "Tiempos de Entrega en Días Laborables",
  "leaveEmptyIfNotUsed": "(dejar vacío si no se usa)",
  "leaveEmptyIfNotUsedDefault": "(dejar vacío si no se usa, predeterminado={{defaultValue}})",
  "loadFromTemplate": "Cargar desde plantilla",
  "loading": "CARGANDO",
  "loadingEllipsis": "Cargando...",
  "loadingSamples": "Cargando muestras",
  "loadingSheet": "Cargando hoja",
  "loadingSheets": "Cargando hojas",
  "location": "Ubicación",
  "locationColon": "Ubicación: {{name}}",
  "locationName": "Nombre de Ubicación",
  "lockItemType": "Bloquear {{itemType}}",
  "lockSamples": "Bloquear muestras",
  "lockUnlockSamplesLabel": "Bloquear/Desbloquear muestras:",
  "locks": "Bloqueos",
  "locksAllFutureAnalysisTasks": "Bloquea todas las tareas de análisis planificadas futuras",
  "locksAllFutureProjectActions": "Bloquea todas las acciones de proyecto planificadas futuras",
  "login": "Iniciar sesión",
  "logout": "Cerrar sesión",
  "maintenanceCreatedSuccessfully": "Mantenimiento \"{{name}}\" creado exitosamente",
  "maintenanceDeletedSuccessfully": "Mantenimiento \"{{name}}\" eliminado exitosamente",
  "maintenanceExpired": "Mantenimiento vencido",
  "maintenanceExpiresInDays": "El mantenimiento vence en menos de {{days}} días",
  "maintenanceMarkedAsCompleted": "Mantenimiento \"{{name}}\" marcado como completado",
  "maintenanceName": "Nombre del mantenimiento",
  "maintenanceUpdatedSuccessfully": "Mantenimiento \"{{name}}\" actualizado exitosamente",
  "mandatoryIfRecurrenceUsed": "(obligatorio si se usa recurrencia)",
  "manualSample": "Muestra manual",
  "manualSheetConfiguration": "Configuración Manual de Hoja",
  "markAsDone": "Marcar como hecho",
  "maxSampleCount": "Número Máximo de Muestras",
  "maxSampleCountLabel": "Núm. máximo de muestras: ",
  "maxTimeBetweenActions": "Tiempo máximo entre acciones (DD:HH:MM)",
  "maxTimeBetweenTasks": "Tiempo máximo entre tareas (DD:HH:MM)",
  "member": "Miembro",
  "memberHasEnabledICalendarOutlookIntegration": "El Miembro Ha Habilitado la Integración iCalendar / Outlook",
  "memberHasEnabledOutlook": "El Miembro Ha Habilitado la Integración iCalendar / Outlook",
  "memberPermissions": "Permisos del miembro",
  "memberPlan": "Plan del Miembro",
  "memberTime": "Tiempo del Miembro",
  "membersGoDirectlyToMemberPlan": "Los miembros van directamente al plan del miembro",
  "message": "Mensaje",
  "metric": "Métrica",
  "minSampleCount": "Número Mínimo de Muestras",
  "minSampleMustBeLowerThanMax": "El número mínimo de muestras debe ser menor que el número máximo",
  "minTimeBetweenActions": "Tiempo mínimo entre acciones (DD:HH:MM)",
  "minTimeBetweenTasks": "Tiempo mínimo entre tareas (DD:HH:MM)",
  "minTimeMustBeSmallerThanMax": "El tiempo mínimo entre debe ser menor que el tiempo máximo entre",
  "minimumDuration": "Duración Mínima: {{time}}",
  "minute": "minuto",
  "missingPasswordRequirements": "Requisitos de contraseña faltantes: {{requirements}}",
  "months": "Meses",
  "movedBy": "Movido Por",
  "movedFrom": "Movido Desde",
  "movedTo": "Movido A",
  "mustBeIcsLink": "Debe ser un enlace .ics",
  "name": "Nombre",
  "namePerformer": "Ejecutor {{name}}",
  "nameTooLongTitle": "Nombre demasiado largo (máximo 100 caracteres)",
  "newAnalysisTaskBundle": "Nuevo Paquete de Tarea de Análisis",
  "newChat": "Nuevo chat",
  "newInstrument": "Nuevo Instrumento",
  "newProject": "Nuevo Proyecto",
  "newProjectTemplateDraft": "BORRADOR de Nueva Plantilla de Proyecto",
  "newStart": "Nuevo Inicio",
  "nextDay": "Día Siguiente",
  "nextWeek": "Semana Siguiente",
  "no": "No",
  "noAnalysesForProduct": "No se encontraron análisis para este producto.",
  "noAssetsFound": "No se encontraron activos",
  "noChanges": "Sin cambios",
  "noChatbotSelected": "Ningún chatbot seleccionado",
  "noDataFound": "No se encontraron datos",
  "noErrorsToDisplay": "No hay errores para mostrar.",
  "noGroup": "Sin grupo",
  "noMembersLoaded": "No se cargaron miembros.",
  "noOfRecurrences": "Núm. de Recurrencias",
  "noReferencesAvailable": "No hay referencias disponibles.",
  "noSamples": "Sin muestras",
  "noSamplesAvailable": "No hay muestras disponibles",
  "noSearchResults": "Sin resultados de búsqueda",
  "noTimeLimitUnlessSpecified": "Sin límite de tiempo a menos que se especifique",
  "none": "Ninguno",
  "default": "Predeterminado",
  "notAvailable": "N/D",
  "notEnoughRoomForDuration": "No hay suficiente espacio para la duración",
  "notStarted": "No Iniciado",
  "numberOfObservations": "Número de Observaciones",
  "numberOfRecurrences": "Número de recurrencias",
  "numericInputBetweenTimeRange": "Por favor introduzca un valor numérico entre 00:00 y 23:59",
  "offsiteCalendar": "Calendario FUERA DE SITIO",
  "ok": "Aceptar",
  "oldInstrument": "Instrumento Antiguo",
  "oldStart": "Inicio Anterior",
  "onlyAdvancedUsersInfo": "Solo los usuarios avanzados usan tanto el inicio más temprano como las conexiones",
  "onsite": "En el sitio",
  "openReferences": "Abrir Referencias",
  "operationalGreyTaskTimePercentage": "Porcentaje de tiempo de tarea gris operativa respecto al tiempo total (OG2T)",
  "operationalTask": "Tarea Operativa",
  "otherPlannerSimulating": "{{initials}} está en modo simulación",
  "outlookLinkLabel": "Enlace iCalendar / Outlook",
  "outputLastMonth": "Salida Mes Pasado",
  "outputThisMonth": "Salida Este Mes",
  "parentColumn": "Columna Principal",
  "password": "Contraseña",
  "paused": "Pausado",
  "peopleSetup": "Configuración de Personas",
  "perSampleDuration": "Duración por muestra (HH:MM:SS)",
  "perSampleDurationForPeopleSetup": "Duración Por Muestra para Configuración de Personas",
  "performerConstraintsCount": "Número de Restricciones de Ejecutor",
  "performerConstraintsLabel": "Restricciones de Ejecutor",
  "permanentApiToken": "Token API permanente",
  "permanentApiTokenDescription": "Este es un token API permanente que le permite acceder a su equipo a través de nuestra API. Cópielo y guárdelo en un lugar seguro.",
  "pinConversation": "Anclar conversación",
  "planned": "Planificado",
  "planner": "Planificador",
  "plannertechLanguage": "Idioma de Plannertech",
  "plannertechVariable": "Variable de Plannertech",
  "pleaseChooseColor": "Por favor elija un Color para el análisis",
  "pleaseFillOutAnalysisName": "Por favor complete el Nombre del Análisis",
  "pleaseFillOutRequiredTaskParams": "Por favor complete los parámetros de tarea requeridos",
  "pleaseGiveEmptyOrFullInput": "Por favor proporcione una entrada vacía o completa",
  "pleaseGiveNumericInput": "Por favor proporcione una entrada numérica",
  "pleaseInputValidDate": "Por favor ingrese una fecha válida",
  "pleaseSelectAtLeastOneItem": "Por favor seleccione al menos un elemento",
  "pleaseSelectColor": "Por favor seleccione un color",
  "pleaseSelectFirstDay": "Por favor seleccione el primer día.",
  "pleaseSelectLastDay": "Por favor seleccione el último día.",
  "pleaseSelectTimezone": "Por favor seleccione una zona horaria",
  "previousDay": "Día Anterior",
  "primary": "Principal",
  "primaryInstrument": "Instrumento Principal",
  "prioritizeByDeadline": "Priorizar IAP por Fecha Límite",
  "prioritizeByPriority": "Priorizar IAP por Número de Prioridad",
  "priority": "Prioridad",
  "priorityHigh": "(Alta)",
  "priorityLow": "(Baja)",
  "priorityMedium": "(Media)",
  "process": "Proceso",
  "processed": "Procesado",
  "processing": "Procesando...",
  "processingInProgress": "Procesando",
  "productName": "Nombre del Producto",
  "project": "Proyecto",
  "projectActions": "acciones de proyecto",
  "projectBatchNumber": "Número de Lote del Proyecto",
  "projectDeadline": "Fecha Límite del Proyecto",
  "projectDescription": "Descripción del Proyecto",
  "projectEarliestStart": "Inicio Más Temprano del Proyecto",
  "projectGroup": "Grupo de proyecto",
  "projectGroupName": "Nombre del Grupo de Proyecto",
  "projectImport": "Importación de Proyecto",
  "projectImportVariable": "Variable de Importación de Proyecto",
  "projectMaterialDescription": "Descripción de Material del Proyecto",
  "projectMaterialNumber": "Número de Material del Proyecto",
  "projectName": "Nombre del Proyecto",
  "projectPriority": "Prioridad del Proyecto",
  "projectReleaseDate": "Fecha de Lanzamiento del Proyecto",
  "projectSupplierName": "Nombre del Proveedor del Proyecto",
  "projectSupplierNumber": "Número del Proveedor del Proyecto",
  "projectTemplate": "plantilla de proyecto",
  "projectTemplates": "Plantillas de Proyecto",
  "projectTimePercentage": "Porcentaje de tiempo de proyecto respecto al tiempo total (P2T)",
  "projectView": "Vista de Proyecto",
  "projects": "Proyectos",
  "projectsAndActions": "Proyectos y Acciones",
  "promptPrefix": "Prefijo de Prompt",
  "promptTooLongTitle": "Prompt demasiado largo (máximo 1200 caracteres)",
  "publish": "PUBLICAR",
  "publishSimulationChanges": "Publicar cambios del modo simulación",
  "qcLibrarian": "QC Librarian",
  "qcLibrarianTitle": "QC Librarian 3.8",
  "recur": "Recurrencia",
  "recurEvery": "Repetir cada",
  "recurrence": "Recurrencia",
  "reduce": "Reducir",
  "references": "Referencias",
  "rejectedFileTypes": "Tipos de Archivo Rechazados",
  "rejectedFilesIncompatible": "Los siguientes archivos fueron rechazados debido a formatos incompatibles",
  "reminderDaysBeforeEndDate": "Recordatorio (días antes de la fecha de fin)",
  "remove": "Eliminar",
  "removeAnalysisFromProduct": "Eliminar {{name}} de este producto",
  "removeAsset": "Eliminar Activo",
  "removeEverything": "Eliminar todo",
  "removeInstrument": "Eliminar Instrumento",
  "reportGenerator": "Generador de Informes",
  "reports": "Informes",
  "repositories": "Repositorios",
  "repositoryCurrentlyProcessing": "El repositorio está procesando actualmente los archivos. Por favor actualice la página para ver el progreso",
  "repositoryHasUnprocessedFiles": "Este repositorio tiene archivos sin procesar",
  "repositoryIsProcessed": "Este repositorio está procesado",
  "repositoryName": "Nombre del Repositorio",
  "reset": "Restablecer",
  "role": "Rol",
  "row": "Fila",
  "rowNumber": " fila {{row}}",
  "runIAP": "Ejecutar IAP",
  "runningIAP": "Ejecutando IAP",
  "sampleAnalysisName": "Nombre del Análisis de Muestra",
  "sampleBatchNumber": "Número de Lote de Muestra",
  "sampleHighestPriority": "La muestra tiene la prioridad más alta",
  "sampleId": "ID de Muestra",
  "sampleIdWithValue": "ID de Muestra: {{id}}",
  "sampleImport": "Importación de Muestra",
  "sampleImportVariable": "Variable de Importación de Muestra",
  "sampleInProgressOnDoneAnalysis": "Muestra en progreso en análisis terminado",
  "sampleIsDone": "La muestra está terminada",
  "sampleLog": "Registro de Muestra",
  "sampleLowestPriority": "La muestra tiene la prioridad más baja",
  "sampleMaterialNumber": "Número de Material de Muestra",
  "sampleName": "Nombre de Muestra",
  "sampleObservation": "Observación de Muestra",
  "sampleObservations": "Observaciones de Muestra",
  "samplePercentage": "Porcentaje de muestra",
  "sampleProductDescription": "Descripción del Producto de Muestra",
  "sampleReceivedDate": "Fecha de Recepción de Muestra",
  "sampleStatus": "Estado de Muestra",
  "sampleView": "Vista de Muestra",
  "samples": "Muestras",
  "samplesWithName": "Muestras con el nombre {{name}}",
  "samplesWithoutProduct": "Muestras sin producto",
  "save": "Guardar",
  "saveAs": "Guardar Como",
  "saveAsDraft": "Guardar como BORRADOR de {{type}}",
  "saveAsNew": "Guardar como nuevo",
  "saveAsNewAnalysis": "Guardar como nuevo análisis",
  "saveAsNewTemplate": "Guardar como nueva plantilla",
  "saveAsType": "Guardar como {{type}}",
  "scrollToTop": "Desplazarse al inicio",
  "scrumView": "Vista Scrum",
  "scrumViewOrdering": "Orden de Vista Scrum",
  "searchBySampleName": "Buscar por nombre de muestra...",
  "searchCountry": "Buscar país",
  "seats": "Puestos",
  "second": "segundo",
  "secondaryInstrumentMustHaveAllowedInstrument": "La configuración del instrumento secundario debe tener al menos un instrumento permitido",
  "selectAll": "Seleccionar Todo",
  "selectChatbot": "Seleccionar chatbot",
  "selectDefaultChatbot": "Seleccionar chatbot predeterminado",
  "selectEntireDay": "Seleccionar el día completo",
  "selectEntireWorkday": "Seleccionar el día laboral completo",
  "selectLocation": "Seleccionar ubicación...",
  "selectSamples": "Seleccionar Muestras",
  "selectState": "Seleccionar estado...",
  "selectTimezone": "Seleccionar zona horaria...",
  "selectType": "Seleccionar Tipo",
  "selectedFilesReadyForSubmit": "Archivos/carpetas seleccionados listos para enviar:",
  "selectedProduct": "Producto Seleccionado",
  "setPlannedValues": "Establecer Valores Planificados",
  "settings": "Configuración",
  "settingsForQcLibrarian": "Configuración para QC Librarian",
  "setupTimeForPeopleSetup": "Tiempo de Configuración para Configuración de Personas",
  "setuptime": "Tiempo de configuración (HH:MM)",
  "sheetName": "Nombre de Hoja",
  "sheetNameLabel": "Nombre de Hoja",
  "sheetType": "Tipo de Hoja",
  "shouldBeEqualTo": "debe ser igual a",
  "shouldNotBeEqualTo": "no debe ser igual a",
  "showAnalyses": "Mostrar Análisis",
  "showErrors": "Mostrar Errores",
  "showLastErrorLog": "Mostrar último registro de errores",
  "showLibrarian": "Mostrar Librarian",
  "showLog": "Mostrar Registro",
  "showMore": "Mostrar más",
  "showOnPlan": "Mostrar en Plan",
  "showProjects": "Mostrar Proyectos",
  "shown": "Visible",
  "simulationMode": "Modo Simulación",
  "simulationModeLogoutWarning": "Actualmente está en modo simulación. ¡Cerrar sesión descartará los cambios!",
  "simulationModeOccupied": "MODO SIMULACIÓN OCUPADO",
  "simulationModeUpper": "MODO SIMULACIÓN",
  "somethingWentWrong": "Algo salió mal",
  "sortByProduct": "Ordenar por producto",
  "sortByTime": "Ordenar Por Tiempo",
  "sortByTimeDescription": "Ordena las acciones de Trabajo Pendiente y Por Hacer por sus fechas límite, y Planificadas y Finalizadas por su tiempo de inicio",
  "speechToTextLanguage": "Idioma de voz a texto",
  "spreadsheetColumnName": "Nombre de Columna de Hoja de Cálculo",
  "stage": "Etapa",
  "standardActions": "Acciones Estándar",
  "start": "Iniciar",
  "startDate": "Fecha de Inicio",
  "startDateCheckboxInfo": "Cuando está marcado, la fecha límite del proyecto, la fecha límite de la acción y el inicio de la acción se moverán en relación al inicio del proyecto",
  "startEndDate": "Fecha de Inicio/Fin",
  "startProcessingInfo": "Esto iniciará el procesamiento del repositorio. Puede tardar un tiempo dependiendo del tamaño del repositorio",
  "startRecurrence": "Iniciar Recurrencia",
  "startTime": "Hora de Inicio",
  "started": "Iniciado",
  "state": "Estado",
  "status": "Estado",
  "submit": "Enviar",
  "successfullyLoaded": "Cargado exitosamente: {{members}}",
  "successfullyUploadedFiles": "Archivos Cargados Exitosamente",
  "systemPrompt": "Prompt del sistema",
  "taskBelongsToTeam": "La tarea pertenece al equipo: {{team}}",
  "taskCount": "Número de Tareas",
  "taskDesignTool": "Herramienta de Diseño de Tareas",
  "taskLog": "Registro de Tareas",
  "taskName": "Nombre de la Tarea",
  "taskPerformerConstraints": "Restricciones de Ejecutor de Tarea",
  "tasks": "Tareas",
  "team": "Equipo",
  "teamChatbot": "Chatbot del equipo",
  "teamLabel": "Equipo: {{name}}",
  "teamMember": "Miembro del Equipo",
  "teamName": "Nombre del Equipo",
  "teamPlan": "Plan del Equipo",
  "teamUsageTitle": "Uso de {{name}}",
  "teams": "Equipos",
  "templateIsDraft": "Esta plantilla de proyecto es un Borrador",
  "templateName": "Nombre de Plantilla",
  "theProjectIsDone": "El proyecto está terminado",
  "timeConstraints": "Restricciones de Tiempo",
  "timeHHMM": "Hora (HH:MM)",
  "timePeriod": "Período de Tiempo",
  "timestamp": "Marca de Tiempo",
  "timezone": "Zona Horaria",
  "to": "A",
  "toConfirmDeletionType": "Para confirmar la eliminación escriba {{keyword}}",
  "toConfirmDeletionTypeDeleteData": "Para confirmar la eliminación escriba {{keyword}} y presione confirmar. Esto eliminará permanentemente los datos de prueba, incluso con el modo simulación. No hay vuelta atrás.",
  "toConfirmDeletionTypeKeyword": "Para confirmar la eliminación escriba {{keyword}} y presione confirmar",
  "toDate": "Hasta la fecha",
  "toDo": "Por Hacer",
  "toTime": "Hasta hora (HH:MM)",
  "toTimeHH": "Hasta hora (HH)",
  "toTimeHHMM": "Hasta hora (HH:MM)",
  "today": "Hoy",
  "tokens": "Tokens",
  "total": "Total",
  "normalSeats": "Normal",
  "tryReloadingOrContactSupport": "Intente recargar, o contacte soporte si el problema persiste.",
  "type": "Tipo",
  "typeBeforeConfirming": "escriba {{keyword}} antes de confirmar",
  "typeOrSelect": "Escriba o seleccione...",
  "typeYourMessage": "Escriba su mensaje...",
  "unassignedSamples": "Muestras no asignadas",
  "unassignedSamplesFor": "Muestras no asignadas para \"{{name}}\"",
  "unflag": "Desmarcar",
  "unflagSample": "Desmarcar Muestra",
  "unlockItemType": "Desbloquear {{itemType}}",
  "unlockSamples": "Desbloquear muestras",
  "unlocks": "Desbloqueos",
  "unlocksAllFutureAnalysisTasks": "Desbloquea todas las tareas de análisis planificadas futuras",
  "unlocksAllFutureProjectActions": "Desbloquea todas las acciones de proyecto planificadas futuras",
  "unnamed": "sin nombre",
  "unpinConversation": "Desanclar conversación",
  "unplan": "Desplanificar",
  "unplanAnalysis": "Desplanificar Análisis",
  "unplanItemType": "Desplanificar {{itemType}}",
  "unplanSample": "Desplanificar Muestra",
  "unplanSelected": "Desplanificar Seleccionados",
  "unplanned": "No Planificado",
  "unplannedProjects": "Proyectos No Planificados",
  "unsavedChangesIn": "Hay cambios sin guardar en:",
  "updateIntegration": "Actualizar Integración",
  "updatedIcalOutlook": "¡iCalendar / Outlook actualizado!",
  "uploadAborted": "¡Carga cancelada!",
  "uploadComplete": "¡Carga completa!",
  "uploadFailedForFile": "La carga falló para el archivo: {{path}}",
  "uploadFinished": "¡Carga Finalizada!",
  "uploadTo": "Cargar a {{name}}",
  "usage": "Uso",
  "used": "Usado",
  "usedAssets": "Activos Usados",
  "usedInstrument": "Instrumento Usado",
  "usedInstruments": "Instrumentos Usados",
  "username": "Usuario",
  "value": "Valor",
  "view": "Ver",
  "viewAllAnalysesForProduct": "Ver todos los análisis para este producto",
  "viewAnalysisSamples": "Ver Muestras de Análisis",
  "viewCompact": "Vista Compacta",
  "viewNormal": "Vista Normal",
  "weekNumber": "Semana {{week}}",
  "weekView": "Vista Semanal",
  "dayView": "Vista Diaria",
  "weekendView": "Vista de Fin de Semana",
  "screen": "Pantalla",
  "clickToSortBy": "Haga clic para ordenar por {{column}}",
  "fileChangedPleaseReselect": "{{file}} ha cambiado. Por favor seleccione el archivo nuevamente",
  "contentTooWideZoomOut": "El contenido es demasiado ancho para la pantalla. Para una mejor experiencia, reduzca el zoom ({{key}} +/-)",
  "week": "Semana",
  "weekly": "Semanal",
  "weeks": "semana(s)",
  "withConnections": "con conexiones",
  "workHours": "Horas de Trabajo",
  "workWeek": "Semana Laboral",
  "years": "Años",
  "yes": "Sí",
  "youAreInSimulationMode": "Está en modo simulación",
  "zeroHours": "0 horas",
  "addCustomer": "Añadir cliente",
  "addGlobalChatbot": "Añadir chatbot global",
  "addGlobalRepository": "Añadir repositorio global",
  "apiKey": "Clave API",
  "authenticationCode": "Código de Autenticación",
  "authenticationCodeSentInfo": "Hemos enviado un código de autenticación a su correo electrónico. Por favor introdúzcalo arriba antes de iniciar sesión",
  "chatbotPrefix": "Prefijo del chatbot",
  "chatbotSystemPrompt": "Prompt del Sistema del Chatbot",
  "chatbotSystemPrompts": "Prompts del Sistema del Chatbot",
  "citationGuidelines": "Directrices de citas",
  "configureMember": "Configurar Miembro",
  "createApiKey": "Crear clave API",
  "creatingProject": "Creando Proyecto",
  "currentQuestion": "Pregunta actual",
  "customerAdminApiKeyForGlobalRepositories": "Clave API de Administrador del Cliente para Repositorios Globales",
  "dateFormatYyyyMmDd": "YYYY-MM-DD",
  "deleteApiKey": "Eliminar clave API",
  "descriptionPrompt": "Prompt de Descripción",
  "editGlobalMessage": "Editar Mensaje Global",
  "editingProject": "Editando Proyecto",
  "editSystemPrompts": "Editar Prompts del Sistema",
  "filePathPrompt": "Prompt de Ruta de Archivo",
  "fillingInSamples": "Rellenando muestras",
  "generalPrefix": "Prefijo general",
  "globalChatbots": "Chatbots Globales",
  "globalRepositories": "Repositorios Globales",
  "hideNextWeek": "Ocultar Semana Siguiente",
  "hideSatSun": "- Sáb/Dom",
  "manageAdmins": "Gestionar Administradores",
  "oneWeek": "1 Semana",
  "openMetricsPanel": "Abrir Panel de Métricas/IAP",
  "openTodoList": "Abrir Lista de Tareas Pendientes",
  "optimizedQuestionPrompt": "Prompt de pregunta optimizado",
  "plannertech": "Plannertech",
  "plannertechSuite": "Plannertech Suite",
  "plannertechTeamPlan": "Plan de Equipo Plannertech",
  "previousConversation": "Conversación anterior",
  "librarianLogoAlt": "Logo de Librarian",
  "qcLibrarianForCompany": "{{company}} QC Librarian",
  "relevantDocumentation": "Documentación relevante",
  "repositoryHasUnprocessedFilesInfo": "Hay archivos sin procesar en este repositorio",
  "repositoryIsEmpty": "Este repositorio está vacío",
  "repositoryPrefix": "Prefijo del repositorio",
  "repositoryProcessingInProgressInfo": "El repositorio está procesando actualmente los archivos. Por favor actualice la página para ver el progreso",
  "sampleAllocation": "Asignación de muestras",
  "mbWithValue": "{{value}} MB",
  "seatsWithCount": "Puestos: {{count}}",
  "excludingToday": "Excluyendo hoy",
  "unplanning": "Desplanificando",
  "activeSeats": "Puestos activos: {{count}}",
  "totalSeats": "Asientos normales: {{count}}",
  "purchasedSeats": "Puestos adquiridos: {{count}}",
  "globalMessage": "Mensaje Global",
  "clearGlobalMessageConfirm": "¿Está seguro de que desea borrar el mensaje global? Esto hará que desaparezca para todos los usuarios.",
  "samplesCount": "Muestras: {{count}}",
  "locations": "Ubicaciones",
  "customers": "Clientes",
  "editCustomer": "Editar cliente",
  "addCustomerTitle": "Añadir Cliente",
  "deleteCustomer": "Eliminar Cliente",
  "customerName": "Nombre del Cliente",
  "customerStatus": "Estado del cliente",
  "active": "Activo",
  "passive": "Pasivo",
  "allowedDomains": "Dominios Permitidos",
  "allowedPerformers": "Ejecutores permitidos",
  "seatsPurchased": "Puestos adquiridos",
  "customerApiKey": "Clave API del cliente",
  "durationFormatDDHH": "DD:HH",
  "durationFormatHHMMSS": "HH:MM:SS",
  "durationFormatHHMM": "HH:MM",
  "durationFormatHH": "HH",
  "durationFormatDDHHMM": "DD:HH:MM",
  "continue": "Continuar",
  "showNextWeek": "Mostrar Semana Siguiente",
  "showSatSun": "+ Sáb/Dom",
  "topDescriptionPrompt": "Prompt de descripción superior",
  "twoWeeks": "2 Semanas",
  "updateHelpPage": "Actualizar Página de Ayuda",
  "userAlreadyLoggedInTakeOver": "El usuario ya ha iniciado sesión. Para tomar el control de la sesión presione confirmar",
  "zoomIn": "Acercar",
  "zoomOut": "Alejar",
  "constraintWarningTitle": "Han ocurrido {{count}} advertencia(s)",
  "assetStatusFree": "Libre",
  "assetStatusBooked": "Reservado",
  "dateTo": "a",
  "futureAnalysisTaskCantBeFinished": "Una tarea de análisis futura no puede ser finalizada",
  "tableNotFound": "Tabla no encontrada",
  "conversionSheetFilename": "Hoja de Conversión.xlsx",
  "selectTeam": "Select a team to log in to",
  "admin": "Admin",
  "customerAdmin": "Admin de Cliente",
  "attachFile": "Adjuntar archivo",
  "removeFile": "Eliminar archivo",
  "fileTooLarge": "El archivo es demasiado grande (máx. 10 MB)",
  "tooManyFiles": "Máximo 3 archivos por mensaje",
  "unsupportedFileType": "Tipo de archivo no compatible. Permitidos: PDF, DOCX, TXT, CSV, PNG, JPG, GIF, WEBP"
}
